// extracted by mini-css-extract-plugin
export default {"header":"styles__header___mkZPr","inputs":"styles__inputs___zP4Pu","link":"styles__link___XBmP7","footerClass":"styles__footerClass___uiAK6"};